import { render, staticRenderFns } from "./MetricPage.vue?vue&type=template&id=e838eda8&scoped=true"
import script from "./MetricPage.vue?vue&type=script&lang=ts"
export * from "./MetricPage.vue?vue&type=script&lang=ts"
import style0 from "./MetricPage.vue?vue&type=style&index=0&id=e838eda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e838eda8",
  null
  
)

export default component.exports